import type { FunctionComponent, HTMLProps } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { QuestionRowProps } from './components/QuestionRow'
import QuestionRow from './components/QuestionRow'
import styles from './QuestionGroup.module.scss'

export const QuestionGroup: FunctionComponent<QuestionGroupProps> = ({
  className,
  questions,
  noBackground,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        styles.questionGroupWrapper,
        `sb-bg-color-${noBackground ? 'text-white' : 'black-05'}`,
        className
      )}
      data-testid="question-group-wrapper"
      {...rest}
    >
      {questions.map(({ questionText, answers }) => (
        <QuestionRow
          key={questionText}
          questionText={questionText}
          answers={answers}
        />
      ))}
    </div>
  )
}

///////// IMPLEMENTATION /////////

export type QuestionGroupProps = {
  /**
   * Optional classname to add additional positioning and styling
   */
  className?: string
  /**
   * Array of question objects containing QuestionRow props
   */
  questions: Array<QuestionRowProps>
  /**
   * Optional boolean to remove the grey background from the component
   */
  noBackground?: boolean
} & HTMLProps<HTMLDivElement>
